export const GET_KB_TAGS_REQUEST = 'GET_KB_TAGS_REQUEST';
export const GET_KB_ARTICLES_REQUEST = 'GET_KB_ARTICLES_REQUEST';
export const GET_KB_ARTICLE_REQUEST = 'GET_KB_ARTICLE_REQUEST';
export const CREATE_KB_ARTICLE_REQUEST = 'CREATE_KB_ARTICLE_REQUEST';
export const CREATE_KB_ARTICLE_FROM_PROJECT_REQUEST = 'CREATE_KB_ARTICLE_FROM_PROJECT_REQUEST';
export const REQUEST_KB_AI_REWRITE_REQUEST = 'REQUEST_KB_AI_REWRITE_REQUEST';
export const UPDATE_KB_ARTICLE_REQUEST = 'UPDATE_KB_ARTICLE_REQUEST';
export const DELETE_KB_ARTICLE_REQUEST = 'DELETE_KB_ARTICLE_REQUEST';
export const GET_KB_ARTICLE_VERSIONS_REQUEST = 'GET_KB_ARTICLE_VERSIONS_REQUEST';

export const getKBTags = (callback) => ({
    type: GET_KB_TAGS_REQUEST,
    payload: { callback },
});

export const getKBArticles = (params, callback) => ({
    type: GET_KB_ARTICLES_REQUEST,
    payload: { params, callback },
});

export const getKBArticle = (id, callback) => ({
    type: GET_KB_ARTICLE_REQUEST,
    payload: { id, callback },
});

export const createKBArticle = (data, callback) => ({
    type: CREATE_KB_ARTICLE_REQUEST,
    payload: { data, callback },
});

export const createKBArticleFromProject = (projectId, data, callback) => ({
    type: CREATE_KB_ARTICLE_FROM_PROJECT_REQUEST,
    payload: { projectId, data, callback },
});

export const requestKBAIRewrite = (projectId, data, callback) => ({
    type: REQUEST_KB_AI_REWRITE_REQUEST,
    payload: { projectId, data, callback },
});

export const updateKBArticle = (id, data, callback) => ({
    type: UPDATE_KB_ARTICLE_REQUEST,
    payload: { id, data, callback },
});

export const deleteKBArticle = (id, callback) => ({
    type: DELETE_KB_ARTICLE_REQUEST,
    payload: { id, callback },
});

export const getKBArticleVersions = (id, callback) => ({
    type: GET_KB_ARTICLE_VERSIONS_REQUEST,
    payload: { id, callback },
});
